import { FC } from 'react';
// Note: CSS classes are defined in public/loading-spinner.css and loaded by HTML

export interface LoadingSpinnerProps {
  text?: string;
}

/**
 * Reusable loading spinner component that matches the HTML initial loader exactly.
 * Uses CSS classes defined in public/loading-spinner.css to ensure consistent styling.
 */
export const LoadingSpinner: FC<LoadingSpinnerProps> = ({ text = 'Loading...' }) => {
  return (
    <div className="loading-spinner-container">
      <div className="loading-spinner" />
      <div className="loading-spinner-text">{text}</div>
    </div>
  );
};